/* eslint-disable react-hooks/exhaustive-deps */
import ICONS from "../../../../../assets/Icons";
import globalText from "../../../../../utils/globalText";
import CommonLayout from "../../../../_utils/CommonLayout";
import CommonDestinationAccount from "../../../../_utils/TransactionCommonComponents/CommonDestinationAccount";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import CommonSourceAccount from "../../../../_utils/TransactionCommonComponents/CommonSourceAccount";

const BeneficiaryTransactionStepAccount = ({
  txnPayLoad,
  setTxnPayLoad,
  openOwner,
  setOpenOwner,
  handleOwnerSelection,
  handleOpenDestinationAccountPopup,
  handleOpenAssociatedAccountsPopup,
  shouldShowAssociatedAccounts,
  isConfidential,
  setIsConfidential,
  associatedAccountsText,
}) => {
  return (
    <div className="w-width-full flex flex-col Qlg:px-padding-base px-padding-md gap-gap-md Qsmd:py-padding-md py-padding-md max-w-tab-width-normal mx-auto">
      <CommonLayout>
        <div className="w-width-full lg:max-w-[var(--create-box-width)]">
          <CommonSourceAccount
            type="source"
            modalOpen={openOwner}
            setModalOpen={setOpenOwner}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            handleOnAccountSelection={handleOwnerSelection}
          />
        </div>

        <div className="w-width-full lg:max-w-[var(--create-box-width)]">
          <CommonDestinationAccount
            transactionPayload={txnPayLoad}
            setTransactionPayload={setTxnPayLoad}
            onSelectAccount={handleOpenDestinationAccountPopup}
            requiresSourceAccount
            showCreateAccount={true}
            createAccountButtonText={globalText?.REGISTER_NEW_ACCOUNT}
            registerRoute="/beneficiary_account_dashboard/create_beneficiary_account"
            showsBalance={false}
            showAssociatedAccounts={shouldShowAssociatedAccounts}
            onViewAssociatedAccounts={handleOpenAssociatedAccountsPopup}
            associatedAccountsText={associatedAccountsText}
          />
        </div>

        <div className="w-width-full lg:max-w-[var(--create-box-width)]">
          <ConfidentialCard
            icon={ICONS?.CONFIDENTIAL_TRANSACTION}
            title={globalText?.CREATE_AS_CONFIDENTIAL}
            note={globalText?.CONFIDENTIAL_TRANSACTION_NOTE}
            toggleState={isConfidential}
            onToggle={() => setIsConfidential(!isConfidential)}
          />
        </div>
      </CommonLayout>
    </div>
  );
};

export default BeneficiaryTransactionStepAccount;
